export default __webpack_public_path__ + "static/media/noBg.9082fe57.svg";